import 'ngVue/build/index';
import 'ngVue/build/plugins';
import angular from 'angular';

export const vrmVueModule = angular.module('vrm.vue-components', ['ngVue', 'ngVue.plugins', 'ui.router']);
export const commonVueOptions = {};
/**
 * Merges an options blob into the vue root constructor config, used to insert vuex and other plugin settings into the angular-rendered vue components.
 * @param options
 * @see $ngVueProvider.setRootVueInstanceProps
 */
export function injectRootVueOptions(options) {
    vrmVueModule.config(/* @ngInject */($ngVueProvider) => {
        $ngVueProvider.setRootVueInstanceProps(options);
    });
    // Extend the commonVueOptions
    Object.keys(options).forEach(key =>{
        commonVueOptions[key] = options[key];
    });
}
